import {
  BaseQueryFn,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  FetchBaseQueryMeta,
} from '@reduxjs/toolkit/query';
import { QueryReturnValue } from '~/api/baseFetch/common.type';

type oneClubAPIResponse<T> = {
  data: T; // 在 Network 的 Response
};

const baseQuery = fetchBaseQuery({
  baseUrl: import.meta.env.VITE_MOE_LOGIN_API,
  method: 'POST',
});

export const MOELoginFetchBase: BaseQueryFn = async (
  args: string | FetchArgs,
  api,
  extraOptions,
) => {
  const result = (await baseQuery(args, api, extraOptions)) as QueryReturnValue<
    oneClubAPIResponse<unknown>,
    FetchBaseQueryError,
    FetchBaseQueryMeta
  >;

  return result;
};
